export default "__VITE_ASSET__BGxxNbze__$_?nuxt_component=async&nuxt_component_name=IOutlineCareTitle__"